// extracted by extract-css-chunks-webpack-plugin
module.exports = {"brandsLeagueList":"brandsLeagueList-18XX_SE1","listItem":"listItem-2QPYctdn","brands_content":"brands_content-12jy4kLM","brands_logo":"brands_logo-2wlMAE1C"};